import classNames from "classnames";
import { get } from "lodash";
import { MdAdd, MdRemove } from "react-icons/md";

const getLevelLabel = (value, labels, translate, needsLevels) => {
  // First try to get from dynamic labels config
  if (labels[String(value)]) {
    return labels[String(value)];
  }
  // Fallback to translate or default
  const defaultLabels = {
    1: translate?.LEVELS?.MINIMUM,
    2: translate?.LEVELS?.PARTIEL,
    3: translate?.LEVELS?.RENFORCE,
    4: translate?.LEVELS?.CONFORT,
    5: translate?.LEVELS?.SUPERIEUR,
  };
  return (
    defaultLabels[value] ||
    `${translate?.LEVELS?.LEVEL_LABEL || "Niveau"} ${value}`
  );
};

const getLevelDescription = (
  value,
  categoryId,
  categoryValue,
  categoriesConfig,
  translate,
) => {
  // First try to get from dynamic categoriesConfig
  const configText = get(categoriesConfig, `${categoryId}.${value}.text`, null);
  if (configText) {
    return configText;
  }

  // Fallback to translate
  const categoryMap = {
    ROUTINE_CARE: "ROUTINE_CARE",
    hospitalization: "HOSPITALIZATION",
    optical: "OPTICAL",
    dental: "DENTAL",
    preventionAndWellBeing: "PREVENTION_AND_WELL_BEING",
  };
  const categoryKey = categoryMap[categoryValue] || "ROUTINE_CARE";
  const levelMap = {
    1: "MINIMUM",
    2: "CONFORT",
    3: "CONFORT_PLUS",
    4: "OPTIMAL",
    5: "MAXIMUM",
  };
  const levelKey = levelMap[value] || "MINIMUM";
  return (
    get(translate, `LEVELS.${categoryKey}.${levelKey}`) ||
    get(translate, `LEVELS.ROUTINE_CARE.${levelKey}`) ||
    "Consultation sans dépassement d'honoraires"
  );
};

const NeedSlider = ({
  category,
  value,
  onChange,
  translate,
  needsLevels = 5,
  labels = {},
  categoriesConfig = {},
}) => {
  const currentLevelLabel = getLevelLabel(
    value,
    labels,
    translate,
    needsLevels,
  );
  const description = getLevelDescription(
    value,
    category.id,
    category.value,
    categoriesConfig,
    translate,
  );

  const handleDecrease = () => {
    if (value > 1) {
      onChange(value - 1);
    }
  };

  const handleIncrease = () => {
    if (value < needsLevels) {
      onChange(value + 1);
    }
  };

  const handleDotClick = (dotValue) => {
    onChange(dotValue);
  };

  return (
    <div className="miltis-need-slider">
      <div className="miltis-need-slider__header">
        <div className="miltis-need-slider__info">
          <img
            src={category.icon}
            alt={category.label}
            className="miltis-need-slider__icon"
          />
          <span className="miltis-need-slider__title">{category.label}</span>
        </div>
        <div className="miltis-need-slider__level">
          <span className="miltis-need-slider__level-label">
            {currentLevelLabel}
          </span>
          <span className="miltis-need-slider__level-divider">•</span>
          <span className="miltis-need-slider__level-description">
            {description}
          </span>
        </div>
      </div>
      <div className="miltis-need-slider__controls">
        <button
          className="miltis-need-slider__btn miltis-need-slider__btn--minus"
          onClick={handleDecrease}
          disabled={value <= 1}
          type="button"
        >
          <MdRemove />
        </button>
        <div className="miltis-need-slider__track">
          <div className="miltis-need-slider__track-line" />
          <div className="miltis-need-slider__track-inner">
            <div
              className="miltis-need-slider__track-filled"
              style={{
                width: `${((value - 1) / (needsLevels - 1)) * 100}%`,
              }}
            />
            {Array.from({ length: needsLevels }, (_, i) => i + 1).map(
              (dotValue) => (
                <button
                  key={dotValue}
                  type="button"
                  className={classNames("miltis-need-slider__dot", {
                    "miltis-need-slider__dot--active": dotValue === value,
                    "miltis-need-slider__dot--filled": dotValue <= value,
                  })}
                  style={{
                    left: `${((dotValue - 1) / (needsLevels - 1)) * 100}%`,
                  }}
                  onClick={() => handleDotClick(dotValue)}
                />
              ),
            )}
            <div
              className="miltis-need-slider__handle"
              style={{
                left: `${((value - 1) / (needsLevels - 1)) * 100}%`,
              }}
            />
          </div>
        </div>
        <button
          className="miltis-need-slider__btn miltis-need-slider__btn--plus"
          onClick={handleIncrease}
          disabled={value >= needsLevels}
          type="button"
        >
          <MdAdd />
        </button>
      </div>
    </div>
  );
};

export default NeedSlider;
